import React from 'react'
import brandingConfig from '../../../config/brandingConfig'
import { useIntl } from 'react-intl'
import UnderMaintainanceImg from './assets/under-maintainance.svg'
import UnderMaintainanceDarkImg from './assets/under-maintainance-dark.svg'
import { useThemeMode } from '../../../_metronic/partials'

const UnderMaintainance = () => {
    const { formatMessage } = useIntl()
    const { mode } = useThemeMode()
    const currentYear = new Date().getFullYear()

    return (
        <div className='d-flex flex-column min-vh-100 px-8'>
            <div className='d-flex flex-column justify-content-center align-items-center flex-grow-1 text-center' style={{ gap: '5rem' }}>
                <img
                    src={mode === 'dark' ? brandingConfig.darkModeLogo : brandingConfig.lightModeLogo}
                    width={315}
                    alt="recordskper.ai-logo"
                    style={{ marginTop: '20px' }}
                />

                <div className='d-flex flex-column align-items-center justify-content-center gap-8 w-md-50 w-100'>
                    <img
                        src={mode === 'dark' ? UnderMaintainanceDarkImg : UnderMaintainanceImg}
                        alt="under-maintainance"
                        className='img-fluid'
                    />
                    <h1 className='mb-0 text-dark' style={{ fontSize: '40px' }}>
                        {formatMessage({ id: `We’re ` })}
                        <span className='text-primary'>{formatMessage({ id: `Upgrading!` })}</span>
                    </h1>
                    <p className='mb-0 font-size-14' style={{ color: '#8898A6' }}>
                        {formatMessage({ id: `RecordsKeeper.AI is under maintenance as we upgrade your experience! We’re adding powerful new features to make your record-keeping smarter, smoother, and even more secure.` })}
                    </p>
                    <div>
                        <h1 className='mb-0 font-size-24 text-dark'>{formatMessage({ id: `We’ll be back in a jiffy.` })}</h1>
                        <p className='mb-0 text-dark font-size-14'>{formatMessage({ id: `Please Come Back Later. Thank you for your patience!` })}</p>
                    </div>
                </div>
            </div>
            <footer className='d-md-flex gap-4 flex-md-row fw-semibold text-gray-500 fs-base justify-content-md-between w-100 d-flex flex-column align-items-center mt-4 mb-8'>
                <p
                    className='text-gray-500 m-0 text-center'
                    dangerouslySetInnerHTML={{
                        __html: `&copy; ${currentYear} ${brandingConfig.companyDetails.displayName}`,
                    }}
                />
                <div className='d-flex'>
                    <a
                        href={brandingConfig.termsUrl}
                        className='me-4 text-gray-500'
                        target='_blank'
                        rel='noreferrer'
                    >
                        {formatMessage({ id: 'Terms of use' })}
                    </a>
                    <a
                        href={brandingConfig.privacyUrl}
                        className='text-gray-500'
                        target='_blank'
                        rel='noreferrer'
                    >
                        {formatMessage({ id: 'Privacy Policy' })}
                    </a>
                </div>
            </footer>
        </div>
    )
}

export default UnderMaintainance
